@if (exportService.isVisible()) {
<div
  class="fixed bottom-4 left-4 z-[9999] w-72 rounded-xl shadow-xl border border-base-300 bg-base-100 overflow-hidden">

  <!-- Header -->
  <div class="flex items-center gap-2 px-3 py-2 bg-base-200/60 border-b border-base-300">
    @if (isRunning()) {
      <span class="loading loading-spinner loading-xs text-primary"></span>
    } @else if (isComplete()) {
      <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 text-success shrink-0" fill="none"
        viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
        <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5" />
      </svg>
    } @else if (hasError()) {
      <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 text-error shrink-0" fill="none"
        viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
        <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z" />
      </svg>
    }
    <span class="text-xs font-semibold flex-1 truncate">
      {{ 'EXPORT.TOAST.TITLE' | translate }}
    </span>
    <button class="btn btn-ghost btn-xs btn-square" (click)="onCloseClick()">
      <svg xmlns="http://www.w3.org/2000/svg" class="h-3.5 w-3.5" fill="none" viewBox="0 0 24 24"
        stroke="currentColor" stroke-width="2.5">
        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
      </svg>
    </button>
  </div>

  <!-- Body -->
  @if (!showCloseConfirm()) {

    <div class="px-3 py-2.5 flex flex-col gap-2">

      @if (isRunning()) {
        <!-- Progress bar -->
        <progress class="progress progress-primary w-full h-1.5"
          [value]="exportService.percent()" max="100"></progress>
        <p class="text-xs text-base-content/60">
          {{ exportService.percent() }}% — {{ exportService.message() }}
        </p>
      } @else if (isComplete()) {
        <p class="text-xs text-success">{{ 'EXPORT.TOAST.COMPLETE' | translate }}</p>
        @if (exportService.fileName()) {
          <p class="text-xs text-base-content/50 truncate">{{ exportService.fileName() }}</p>
        }
      } @else if (hasError()) {
        <p class="text-xs text-error">{{ 'EXPORT.TOAST.ERROR' | translate }}</p>
        @if (exportService.message()) {
          <p class="text-xs text-base-content/50 truncate">{{ exportService.message() }}</p>
        }
      }

      <!-- Actions (only when complete or running) -->
      @if (isComplete() || isRunning()) {
        <div class="flex gap-1.5 mt-0.5">

          @if (isComplete()) {
            <button class="btn btn-xs btn-primary gap-1 flex-1" (click)="onDownload()">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-3.5 w-3.5" fill="none"
                viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round"
                  d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5M16.5 12 12 16.5m0 0L7.5 12m4.5 4.5V3" />
              </svg>
              {{ 'EXPORT.TOAST.DOWNLOAD' | translate }}
            </button>
          }

          @if (!exportService.emailSent()) {
            <button class="btn btn-xs btn-ghost gap-1" [class.flex-1]="isRunning()"
              (click)="onSendEmail()">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-3.5 w-3.5" fill="none"
                viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round"
                  d="M21.75 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25m19.5 0v.243a2.25 2.25 0 0 1-1.07 1.916l-7.5 4.615a2.25 2.25 0 0 1-2.36 0L3.32 8.91a2.25 2.25 0 0 1-1.07-1.916V6.75" />
              </svg>
              {{ 'EXPORT.TOAST.SEND_EMAIL' | translate }}
            </button>
          } @else {
            <span class="text-xs text-base-content/50 self-center">
              {{ 'EXPORT.TOAST.EMAIL_SENT' | translate }}
            </span>
          }

        </div>
      }

    </div>

  } @else {

    <!-- Close confirmation panel -->
    <div class="px-3 py-2.5 flex flex-col gap-2">
      <p class="text-xs text-base-content/70">
        @if (isRunning()) {
          {{ 'EXPORT.TOAST.CONFIRM_CLOSE_RUNNING' | translate }}
        } @else {
          {{ 'EXPORT.TOAST.CONFIRM_CLOSE_DONE' | translate }}
        }
      </p>
      <p class="text-xs text-base-content/50">{{ 'EXPORT.TOAST.CONFIRM_EMAIL_VALIDITY' | translate }}</p>
      <div class="flex gap-1.5">
        <button class="btn btn-xs btn-ghost flex-1" (click)="cancelClose()">
          {{ 'EXPORT.TOAST.CONFIRM_BACK' | translate }}
        </button>
        <button class="btn btn-xs btn-ghost flex-1" (click)="confirmClose(false)">
          {{ 'EXPORT.TOAST.CONFIRM_NO' | translate }}
        </button>
        <button class="btn btn-xs btn-primary flex-1" (click)="confirmClose(true)">
          {{ 'EXPORT.TOAST.CONFIRM_YES' | translate }}
        </button>
      </div>
    </div>

  }

</div>
}
